import React from 'react';

import Header from '../../components/header';
import Locations from './locations';
import GetInTouchForm from './get-in-touch';
import SocialMedia from './social-media';
import TenderWhistleblower from './tender-whistleblower';

import { useLanguage } from '../../helpers/language-context';

const Contact = () => {
  const { translations } = useLanguage();

  return (
      <div>
        <Header title={translations.contact.title ?? 'Contact Us'} bgImg="/assets/images/MBRSA.JPG" color="#28357B" />
        <Locations />
        <GetInTouchForm />
        <SocialMedia />
        <TenderWhistleblower />
      </div>
  );
};

export default Contact;
